import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const islands = [
  {
    name: "Ngazidja",
    image: "https://www.vanilla-islands.org/wp-content/uploads/2015/12/accueil-comores-plage-barque.jpg",
  },
  {
    name: "Anjouan",
    image: "https://www.nomade-aventure.com/Content/Images/ImgProduits/COM/11221/701448_QuatreTiers.ori.jpg",
  },
  {
    name: "Moheli",
    image: "https://d3e1m60ptf1oym.cloudfront.net/2e4f6c35-7933-42d8-bb10-4c4758c06660/2016_12_BARATHIEU_Moheli_4064_uxga.jpg",
  },
];

export default function Islands() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [offset, setOffset] = useState(0);
  const navigate = useNavigate();

  // 🔥 PARALLAX PROPRE
  useEffect(() => {
    const handleScroll = () => {
      if (!ref.current) return;

      const rect = ref.current.getBoundingClientRect();
      const progress = rect.top / window.innerHeight;

      setOffset(progress * 40);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 🔥 ANIMATION
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="
        relative w-full
        min-h-screen
        flex items-center justify-center text-center
        py-16 md:py-24
      "
    >

      {/* Background */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <img
          src="https://media-cdn.tripadvisor.com/media/photo-c/1280x250/0f/63/53/ae/le-trous-du-prophete.jpg"
          className="w-full h-full object-cover scale-105"
          style={{ transform: `translateY(${offset}px)` }}
          alt="background"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40" />
      </div>

      {/* Content */}
      <div className="w-full max-w-7xl xl:max-w-[1400px] px-4 sm:px-6">

        <h2
          className={`
            text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-10 sm:mb-14
            transition-all duration-700
            ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}
          `}
        >
          Choisissez votre île
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">

          {islands.map((island, index) => (
            <div
              key={index}
              className={`
                group relative h-[220px] sm:h-[260px] lg:h-[300px]
                rounded-2xl overflow-hidden cursor-pointer
                transition duration-500 hover:-translate-y-1
                shadow-md hover:shadow-xl
                ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
              `}
              onClick={() =>
                navigate(`/hotels?destination=${encodeURIComponent(island.name)}&checkIn=&checkOut=`)
              }
              style={{ transitionDelay: `${0.2 + index * 0.1}s` }}
            >

              {/* Image */}
              <img
                src={island.image}
                alt={island.name}
                className="absolute inset-0 w-full h-full object-cover transition duration-500 group-hover:scale-105"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition" />

              {/* Content */}
              <div className="absolute bottom-4 left-4 right-4 text-left">

                <h3 className="text-xl sm:text-2xl font-semibold text-white">
                  {island.name}
                </h3>

                <div className="
                  mt-2 flex items-center justify-between
                  opacity-100 sm:opacity-0
                  sm:translate-y-4
                  sm:group-hover:opacity-100 sm:group-hover:translate-y-0
                  transition-all duration-300
                ">
                  <span className="text-white/90 text-sm">
                    Voir les hébergements
                  </span>

                  <span className="text-white text-lg group-hover:translate-x-1 transition">
                    →
                  </span>
                </div>

              </div>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}